import React from 'react'
import messages from './messages'
import { FormattedMessage } from 'react-intl'

const OrderStage = ({ stage }) => (
  <div className="flex items-center w-full truncate justify-center lg:justify-start">
    <span className={{
      PENDING: 'w-2 h-2 rounded-full bg-purple-400',
      READY: 'w-2 h-2 rounded-full bg-positive',
      CLOSED: 'w-2 h-2 rounded-full bg-blue-400',
      IN_PROGRESS: 'w-2 h-2 rounded-full bg-red-400',
      AMENDING: 'w-2 h-2 rounded-full bg-yellow-400',
    }[stage] || 'w-2 h-2 rounded-full bg-gray-400'} />

    <span className="ml-2 capitalize hidden lg:flex">
      {{
        PENDING: <FormattedMessage {...messages.stagePending} />,
        READY: <FormattedMessage {...messages.stageReady} />,
        CLOSED: <FormattedMessage {...messages.stageClosed} />,
        IN_PROGRESS: <FormattedMessage {...messages.stageInProgress} />,
        AMENDING: <FormattedMessage {...messages.stageAmending} />,
      }[stage] || stage }
    </span>
  </div>
)

export default OrderStage
